import { render, staticRenderFns } from "./Laundry.vue?vue&type=template&id=5132be8c&"
import script from "./Laundry.vue?vue&type=script&lang=js&"
export * from "./Laundry.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports